module.exports = __webpack_public_path__ + "img/Group 1420.78edf842.svg";